import engine from "store/src/store-engine";
import sessionStorage from "store/storages/sessionStorage";
import cookieStorage from "store/storages/cookieStorage";
import memoryStorage from "store/storages/memoryStorage";

export default engine.createStore([
  sessionStorage,
  cookieStorage,
  memoryStorage
]);